import { MONITORING_WEEKDAY_LABELS } from '../constants/monitoringScheduleConstants';
import { formatScheduleDisplayDate, normalizeTimeOfDay } from './monitoringScheduleDateUtils';

import type { IMonitoringSchedulePayload } from 'constants/interfaces/IMonitoringSchedule';

const getFrequencyUnit = (frequency: string, interval: number): string => {
  let unit: string;

  if (frequency === 'daily') {
    unit = 'day';
  } else if (frequency === 'weekly') {
    unit = 'week';
  } else {
    unit = 'month';
  }

  return interval > 1 ? `${unit}s` : unit;
};

export const buildScheduleRecurrenceSummary = (
  schedule: Pick<IMonitoringSchedulePayload, 'recurrence'>,
): string => {
  const { recurrence } = schedule;
  if (!recurrence) {
    return '';
  }

  const interval = recurrence.interval || 1;
  const unit = getFrequencyUnit(recurrence.frequency, interval);
  let days = '';

  if (recurrence.frequency === 'weekly' && recurrence.daysOfWeek?.length) {
    days = ` on ${recurrence.daysOfWeek
      .map((day) => MONITORING_WEEKDAY_LABELS[day])
      .join(' & ')}`;
  }

  const time = normalizeTimeOfDay(recurrence.timeOfDay || '08:00:00').slice(0, 5);

  return `Every ${interval} ${unit}${days} at ${time}`;
};

export const buildSchedulePreviewText = ({
  schedule,
  noEndDate,
}: {
  schedule: IMonitoringSchedulePayload,
  noEndDate: boolean,
}): string => {
  const { recurrence } = schedule;
  const interval = recurrence.interval || 1;
  const unit = getFrequencyUnit(recurrence.frequency, interval);
  let days = '';

  if (recurrence.frequency === 'weekly' && recurrence.daysOfWeek?.length) {
    days = ` on ${recurrence.daysOfWeek
      .map((day) => MONITORING_WEEKDAY_LABELS[day])
      .join(' & ')}`;
  }

  const time = normalizeTimeOfDay(recurrence.timeOfDay || '08:00:00').slice(0, 5);
  const startDate = formatScheduleDisplayDate(recurrence.startDate);
  const endText = noEndDate || !recurrence.endDate
    ? 'no end date'
    : `until ${formatScheduleDisplayDate(recurrence.endDate)}`;

  return `Runs every ${interval} ${unit}${days} at ${time} (${schedule.timezone}), from ${startDate} ${endText}.`;
};
